var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7804 4.20015C10.6582 4.32477 10.5898 4.49231 10.5898 4.66682C10.5898 4.84132 10.6582 5.00886 10.7804 5.13348L11.847 6.20015C11.9717 6.3223 12.1392 6.39072 12.3137 6.39072C12.4882 6.39072 12.6558 6.3223 12.7804 6.20015L15.2937 3.68682C15.6289 4.42761 15.7304 5.25297 15.5847 6.05291C15.4389 6.85285 15.0528 7.58938 14.4779 8.16434C13.9029 8.73929 13.1664 9.12537 12.3665 9.27112C11.5665 9.41687 10.7412 9.31537 10.0004 8.98015L5.39371 13.5868C5.12849 13.852 4.76878 14.001 4.39371 14.001C4.01863 14.001 3.65892 13.852 3.39371 13.5868C3.12849 13.3216 2.97949 12.9619 2.97949 12.5868C2.97949 12.2117 3.12849 11.852 3.39371 11.5868L8.00037 6.98015C7.66515 6.23936 7.56365 5.41399 7.7094 4.61405C7.85515 3.81411 8.24123 3.07759 8.81619 2.50263C9.39114 1.92767 10.1277 1.5416 10.9276 1.39584C11.7275 1.25009 12.5529 1.35159 13.2937 1.68682L10.787 4.19348L10.7804 4.20015Z",
    stroke: "#53EAFD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanner);
export default __webpack_public_path__ + "static/media/spanner.3c2a11dda5e63aca45bde8e23ab9966a.svg";
export { ForwardRef as ReactComponent };